module.exports = __webpack_public_path__ + "img/bg_function01_1_t.e7493295.png";